import React from 'react';
import { browserHistory } from 'react-router';
import { pushSelectContentEventFromGrid } from 'utils/analytics/pushSelectContentEvent';
import { FadeInImage } from '../../../../../components/FadeInImage';
import './style.scss';
import useMenuRedirect from '../../../../Menu/hooks/useMenuRedirect';
import useRenderChapas from '../../../../../hooks/useRenderChapas';
import { getRegion } from '../../../../../utils/Region';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { useNavigate } from 'react-router-dom';
import { useShowOverlayTitle } from 'containers/CarouselsDisplay/components/ContentsCarouselContainer/hooks/useShowOverlayTitle';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

const ContentCard = ({ item, ordering }) => {
  const { renderLabel } = useRenderChapas();
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const { isMobile } = useVerifyIsMobile();
  const navigate = useNavigate();

  const { showOverlay } = useShowOverlayTitle(item);

  const handleCardClick = e => {
    e.stopPropagation();
    pushSelectContentEventFromGrid(item, nodesSelected, ordering);

    //  Verificar si no es live para mandar al canal
    
    if (getContentListV1?.IsLive(item)) {
      // navegar al canal
      navigateToChannel(item);
      return;
    }
    //  Redireccionamiento
    navigate(`/${getRegion()}/vcard/homeuser/${getContentListV1?.titleUri(item)}/${item?.id}`);
  };

  return (
    <>
      <div className="content-card" onClick={handleCardClick}>
        {renderLabel(item)}
        <FadeInImage
          imageSrc={
            isMobile ? getContentListV1?.getImage(item, IMG_SIZE?.VERTICAL): getContentListV1?.getImage(item,IMG_SIZE?.HORIZONTAL)
          }
          imageAlt="content"
          classNames={['content-card__img']}
          width={isMobile ? 101 : 255}
          height={isMobile ? 152 : 144}
        />

        {
          showOverlay &&
          <div className="content-card__overlay">
            <span className="content-card__overlay__title">
              {item?.title}
            </span>
          </div>
        }

      </div>
    </>
  );
};

export default ContentCard;
